import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Drawer, Tabs, Tab } from '@unite-us/app-components';
import { hbh1509ClientsDrawerP2 } from 'common/utils/FeatureFlags/flags';
import { fetchGroupContact } from 'actions/Contact/Group';
import FacesheetOverview from 'src/pages/facesheet/_id/FacesheetOverview';
import FacesheetProfile from 'src/pages/facesheet/_id/profile/FacesheetProfile';
import FacesheetCases from 'src/pages/facesheet/_id/cases/FacesheetCases';
import DrawerHeader from './DrawerHeader';

const ClientsDrawer = ({
  open,
  onClose,
  context,
  contact,
  groupId,
  fetchGroupContact: fetchGroupContactAction,
  hbh1509ClientsDrawerP2Enabled,
  hideCloseButton,
  DrawerComponent,
}) => {
  const [tabValue, setTabValue] = useState('overview');
  const [fullContact, setFullContact] = useState(null);
  const [isFetchingFull, setIsFetchingFull] = useState(false);

  const tabsConfig = {
    overview: {
      label: 'Overview',
      show: true,
    },
    profile: {
      label: 'Profile',
      show: true,
    },
    latestActivity: {
      label: 'Latest Activity',
      show: true,
    },
  };
  useEffect(() => {
    let mounted = true;

    if (!contact?.id) {
      return () => {
        mounted = false;
      };
    }

    setIsFetchingFull(true);
    fetchGroupContactAction(groupId, contact.id)
      .then((res) => {
        if (mounted) setFullContact(res.data.data);
      })
      .finally(() => {
        if (mounted) setIsFetchingFull(false);
      });

    return () => {
      mounted = false;
    };
  }, [groupId, contact?.id, fetchGroupContactAction]);

  const handleTabChange = (value) => setTabValue(value);
  const setTabContent = () => {
    switch (tabValue) {
      case 'overview':
        return (
          <FacesheetOverview
            id={contact?.id}
            isClientsDrawer
            contact={fullContact}
            visibilityConfig={{
              overview: {
                showTab: true,
                showCareCoordinator: true,
                showCareTeam: true,
                showFamilyMembers: true,
                showOpenCases: true,
                showNotes: true,
                showMessages: true,
              },
            }}
            getClientRelationship={() => {}}
          />
        );
      case 'profile':
        return (
          <FacesheetProfile
            {...context}
            params={{ id: contact?.id }}
            contact={contact}
            isClientsDrawer
          />
        );
      case 'latestActivity':
        return (
          hbh1509ClientsDrawerP2Enabled ?
            (
              <FacesheetCases
                id={contact?.id}
                isClientsDrawer
                contact={contact}
              />
            ) : (<div className="container">Coming Soon</div>)
        );
      default:
        return null;
    }
  };

  const DrawerContent = (
    <div>
      <div className="container">
        <DrawerHeader
          contact={contact}
          fullContact={fullContact}
          isFetchingFull={isFetchingFull}
          groupId={groupId}
        />
        <Tabs
          id="client-drawer-tabs"
          className="facesheet-tabs"
          onChange={handleTabChange}
          value={tabValue}
        >
          {Object.keys(tabsConfig).map((tab) => {
            const { label, show } = tabsConfig[tab];
            return show ? (
              <Tab
                id={`clientsDrawer-${tab}-tab`}
                label={label}
                value={tab}
                className="px-4 hover:bg-medium-fill-blue bg-white"
                key={tab}
              />
            ) : null;
          })}
        </Tabs>
      </div>
      <div className="bg-medium-fill-grey p-2 min-h-screen">
        {setTabContent()}
      </div>
    </div>
  );

  const DrawerContainer = DrawerComponent ? (
    <DrawerComponent open={open} setOpen={onClose}>
      {DrawerContent}
    </DrawerComponent>
  ) : (
    <Drawer
      open={open}
      secondary
      topOffset="65px"
      width="40%"
      onClose={onClose}
      hideCloseButton={hideCloseButton}
    >
      {DrawerContent}
    </Drawer>
  );

  return DrawerContainer;
};

ClientsDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  context: PropTypes.object,
  contact: PropTypes.shape({
    id: PropTypes.string.isRequired,
    last_name_first_name: PropTypes.string.isRequired,
  }).isRequired,
  hbh1509ClientsDrawerP2Enabled: PropTypes.bool,
  groupId: PropTypes.string.isRequired,
  fetchGroupContact: PropTypes.func.isRequired,
};
function mapStateToProps(state) {
  const { session } = state;
  return {
    hbh1509ClientsDrawerP2Enabled: hbh1509ClientsDrawerP2(state),
    groupId: session.groupId,
  };
}

export default connect(
  mapStateToProps,
  { fetchGroupContact },
)(ClientsDrawer);
